import { render } from "./confirm_dialog.vue?vue&type=template&id=464d0760&ts=true"
import script from "./confirm_dialog.vue?vue&type=script&lang=ts"
export * from "./confirm_dialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__